import React from 'react';
import ReactDOM from 'react-dom';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
//import darkBaseTheme from 'material-ui/styles/baseThemes/darkBaseTheme';  muiTheme={getMuiTheme(darkBaseTheme)}
import getMuiTheme from 'material-ui/styles/getMuiTheme';
import App from './App';
import './index.css';

const muiTheme = getMuiTheme({
  palette: {
    textColor: '#FFFFFF',
    primary1Color: '#993322',
    canvasColor: '#881122',
  },
  appBar: {
    height: 50,
  },
});

const Full = () => (
  <MuiThemeProvider muiTheme={muiTheme}>
    <App />
  </MuiThemeProvider>
);

ReactDOM.render(
  <Full />,
  document.getElementById('root')
);



// WEBPACK FOOTER //
// ./src/index.js